import { Box, TextField } from "@mui/material";
import InputMask from "react-input-mask";
import { useTranslation } from "react-i18next";
import ComercialInterfaceHeader from "@/components/comercial/ComercialInterfaceHeader";
import {sharedStyles} from "@/styles/shared";
import {
    showCustomInputFieldError,
    validateCnpj, validatePhoneNumber
} from "@/pages/petAndBeauty/Comercial/StoresPages/storeValidationSchemas";

export const StoreDataForm = ({ register, errors, refs, cnpj, setCnpj, phone, setPhone, submittedOnce }: any) => {
    const { t } = useTranslation();

    return (
        <>
            <ComercialInterfaceHeader title={t("storePage.management.add.title")} />
            <Box sx={sharedStyles.verticalContent}>
                <Box sx={sharedStyles.dividedFormContainer}>
                    <TextField
                        size="small"
                        label={t("storePage.management.add.form.name")}
                        inputRef={refs.storeName}
                        {...register("storeName")}
                        error={!!errors.storeName}
                        helperText={errors.storeName?.message}
                        fullWidth
                    />
                    <InputMask mask="99.999.999/9999-99" maskChar="_" value={cnpj} onChange={(e) => setCnpj(e.target.value)}>
                        <TextField
                            size="small"
                            fullWidth
                            label={t("storePage.management.add.form.cnpj")}
                            inputRef={refs.cnpj}
                            error={showCustomInputFieldError(!validateCnpj(cnpj), submittedOnce)}
                            helperText={showCustomInputFieldError(!validateCnpj(cnpj), submittedOnce) && t("storePage.management.add.invalidCnpj")}
                        />
                    </InputMask>
                </Box>

                <Box sx={sharedStyles.dividedFormContainer}>
                    <InputMask mask="(99) 9.9999-9999" maskChar="_" value={phone} onChange={(e) => setPhone(e.target.value)}>
                        <TextField
                            label={t("storePage.management.add.form.phone")}
                            size="small"
                            fullWidth
                            inputRef={refs.phone}
                            error={showCustomInputFieldError(!validatePhoneNumber(phone), submittedOnce)}
                            helperText={showCustomInputFieldError(!validatePhoneNumber(phone), submittedOnce) ? t("storePage.management.add.invalidPhone") : ""}
                        />
                    </InputMask>
                    <TextField
                        size="small"
                        label={t("storePage.management.add.form.email")}
                        placeholder={t("storePage.management.add.form.emailPlaceholder")}
                        fullWidth
                        inputRef={refs.email}
                        {...register("email")}
                        error={!!errors.email}
                        helperText={errors.email?.message}
                    />
                </Box>
                <TextField
                    size="small"
                    label={t("storePage.management.add.form.description")}
                    placeholder={t("storePage.management.add.form.descriptionPlaceholder")}
                    fullWidth
                    multiline
                    rows={5}
                    inputRef={refs.description}
                />
            </Box>
        </>
    );
};